import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue'
import VSelect from './VSelect.vue'
import VCheckbox from './VCheckbox.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'VIsAiListSelect',
  props: {
    small: { type: Boolean },
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  small?: boolean,
  modelValue?: string[]
}




const selectRef = ref()

const options = [
  { value: 'activate_ai_moderation', label: 'Activate AI Moderation', group: 'moderation' },
  { value: 'disable_ai_moderation', label: 'Disable AI Moderation', group: 'moderation' },
  { value: 'activate_ai_engagement', label: 'Activate AI Engagement', group: 'engagement' },
  { value: 'disable_ai_engagement', label: 'Disable AI Engagement', group: 'engagement' }
]

const selectedOptions = ref<string[]>(props.modelValue || [])

watch(() => props.modelValue, val => {
  if (val) selectedOptions.value = [...val]
})

const toggleOption = (value: string, checked: boolean) => {
  const option = options.find(opt => opt.value === value)
  if (!option) return

  // Удаляем из текущего выбора всё, что из той же группы
  selectedOptions.value = selectedOptions.value.filter(
    v => options.find(o => o.value === v)?.group !== option.group
  )

  // Добавляем выбранный, если включили
  if (checked) {
    selectedOptions.value.push(value)
  }

  emit('update:modelValue', [...selectedOptions.value])
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VSelect, {
    ref_key: "selectRef",
    ref: selectRef,
    small: props.small,
    "menu-class": "template-select-menu",
    "mobile-close": ""
  }, {
    default: _withCtx(() => [
      _createTextVNode(" Moderation Settings ")
    ]),
    top: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (option) => {
        return _createVNode(VCheckbox, {
          key: option.value,
          label: option.label,
          "model-value": selectedOptions.value.includes(option.value),
          "onUpdate:modelValue": val => toggleOption(option.value, val)
        }, null, 8, ["label", "model-value", "onUpdate:modelValue"])
      }), 64))
    ]),
    _: 1
  }, 8, ["small"]))
}
}

})